export default __webpack_public_path__ + "static/media/mark-text-lg.0074db43.svg";